import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-4543b0b0");

var _hoisted_1 = {
  class: "page-wrapper"
};
var _hoisted_2 = {
  class: "info-container"
};
var _hoisted_3 = {
  class: "banner"
};
var _hoisted_4 = {
  key: 0,
  class: "img-wrapper"
};
var _hoisted_5 = {
  key: 1,
  class: "img--wrapper"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  key: 2,
  class: "banner-info img--wrapper"
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/banner-title.png!w480",
  alt: ""
}, null, -1);

var _hoisted_9 = [_hoisted_8];
var _hoisted_10 = {
  class: "list-container"
};
var _hoisted_11 = {
  class: "integral-info"
};
var _hoisted_12 = {
  class: "info_wrapper"
};
var _hoisted_13 = {
  class: "wrapper_button"
};

var _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "division"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "division-title"
}, "邀请送豪礼")], -1);

var _hoisted_15 = {
  class: "tab-wrapper"
};
var _hoisted_16 = {
  class: "list-container"
};

var _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Header = _resolveComponent("Header");

  var _component_van_loading = _resolveComponent("van-loading");

  var _component_van_image = _resolveComponent("van-image");

  var _component_my_red_packet = _resolveComponent("my-red-packet");

  var _component_list_wrapper = _resolveComponent("list-wrapper");

  var _component_ListInvitedWrapper = _resolveComponent("ListInvitedWrapper");

  var _component_ListJoinWrapper = _resolveComponent("ListJoinWrapper");

  var _component_list_other_activity_wrapper = _resolveComponent("list-other-activity-wrapper");

  var _component_van_overlay = _resolveComponent("van-overlay");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    title: $options.title,
    headerBackground: ""
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_ctx.loadingBanner ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_image, {
    width: "100%",
    height: "224px"
  }, {
    loading: _withCtx(function () {
      return [_createVNode(_component_van_loading, {
        type: "spinner",
        size: "20"
      })];
    }),
    _: 1
  })])) : _ctx.bannerImage ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
    src: _ctx.bannerImage,
    alt: ""
  }, null, 8, _hoisted_6)])) : (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_9)), _createVNode(_component_my_red_packet)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("ul", null, [_createElementVNode("li", {
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onClickInfo && $options.onClickInfo.apply($options, arguments);
    })
  }), _createElementVNode("li", {
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.onClickShop && $options.onClickShop.apply($options, arguments);
    })
  })])])])]), $data.invitedList.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("ul", null, [_createElementVNode("li", {
    class: _normalizeClass({
      active: _ctx.activeIndex === 0
    }),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.resetActivityIndex(0);
    })
  }, "活动列表", 2), _createElementVNode("li", {
    class: _normalizeClass({
      active: _ctx.activeIndex === 1
    }),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.resetActivityIndex(1);
    })
  }, "邀请记录", 2), _createElementVNode("li", {
    class: _normalizeClass({
      active: _ctx.activeIndex === 2
    }),
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $options.resetActivityIndex(2);
    })
  }, "参与记录", 2)])]), _createElementVNode("div", _hoisted_16, [_ctx.activeIndex === 0 ? (_openBlock(), _createBlock(_component_list_wrapper, {
    key: 0,
    ref: "listWrapper",
    isSelected: _ctx.isSelected,
    categoryId: 0
  }, null, 8, ["isSelected"])) : _createCommentVNode("", true), _ctx.activeIndex === 1 ? (_openBlock(), _createBlock(_component_ListInvitedWrapper, {
    key: 1
  })) : _createCommentVNode("", true), _ctx.activeIndex === 2 ? (_openBlock(), _createBlock(_component_ListJoinWrapper, {
    key: 2,
    "onUpdate:activeIndex": _ctx.updateActiveIndex
  }, null, 8, ["onUpdate:activeIndex"])) : _createCommentVNode("", true)])], 64)) : _createCommentVNode("", true), _createVNode(_component_list_other_activity_wrapper, {
    categoryId: 0
  })]), _createVNode(_component_van_overlay, {
    show: $data.show,
    "z-index": "3",
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return $data.show = false;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: _normalizeClass(["overlay-wrapper", {
          active: $data.show
        }]),
        onClick: _cache[5] || (_cache[5] = _withModifiers(function () {}, ["stop"]))
      }, [_createTextVNode(" uid:" + _toDisplayString(_ctx.uid), 1), _hoisted_17, _createTextVNode(" toke:" + _toDisplayString(_ctx.token), 1), _hoisted_18, _createTextVNode(" time:" + _toDisplayString(_ctx.time), 1), _hoisted_19], 2)];
    }),
    _: 1
  }, 8, ["show"])]);
}